module.exports = "/_next/static/images/business-planning-header-9046789d3ab2973914f49c19f419bb66.webp";